import { render, staticRenderFns } from "./ResubmittedReports.vue?vue&type=template&id=06b0c0e8"
import script from "./ResubmittedReports.vue?vue&type=script&lang=js"
export * from "./ResubmittedReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports